module.exports = __webpack_public_path__ + "img/talron-qna-plus.07cfcb02.svg";